app.service('cartRetrieve', function (modal, loading, log, front, simpleToastr, message, sessionStorage, broker, csrfToken) {
	const CART_MERGE_BUNDLE = 'cart-merge-bundle';
	function setAction(action, cart, callback) {
		loading.start();
		logAction(action);
		let data = {
			action: action,
			previousCartCookie: cart
		}
		function post(token) {
			data['_csrf'] = token;
			$.ajax({
				url: '/merge-carts.ltr',
				type: 'POST',
				data: data,
				success: function (json) {
					if (json.status === 'SUCCESS') {
						modal.close();
						if (callback) {
							callback();
						} else {
							loading.redirect('/cart.bhtml');
						}
					} else {
						setBundleModal(false);
						simpleToastr.afterReloadMessage(false);
						modal.alert('Błąd łączenia koszyków. Spróbuj ponownie', function () {
							loading.redirect({
								href: '/cart.bhtml',
								soft: true
							});
						});
					}
				},
				error: function () {
					setBundleModal(false);
					simpleToastr.afterReloadMessage(false);
					modal.alert('Błąd w komunikacji łączenia koszyków. Spróbuj ponownie');
				}
			})
		}
		csrfToken.get(function (token) {
			post(token);
		});

	}
	function logAction(action) {
		log.event({ id: 'laczenie-koszykow', f03: action });
		UA.push({
			event: 'laczenie-koszykow',
			action: action
		});
	}
	let isOneInit = false;
	function setBundleModal(status){
		if(status){
			sessionStorage.setItem(CART_MERGE_BUNDLE, 'true');
		} else {
			sessionStorage.removeItem(CART_MERGE_BUNDLE);
		}
	}
	function init() {
		if (!isOneInit) {
			isOneInit = true;
			$('body').on('click', '.js-cart-retrive-action', function () {
				let $this = $(this);
				let action = $this.data('action');
				let cart = $this.data('cart');
				let isBundle = $this.data('bundle');
				let page = front.page();
				if (action == 'MERGE') {
					simpleToastr.afterReloadMessage(`<h2>Produkty zostały dodane do koszyka</h2>`);
					if (isBundle) {
						setBundleModal(true);
					}
				} else if (action == 'OVERRIDE_LAST') {
					simpleToastr.afterReloadMessage(`<h2>Wcześniejszy koszyk został usunięty</h2>`);
				} else if (action == 'OVERRIDE_CURRENT') {
					simpleToastr.afterReloadMessage(`<h2>Koszyk został przywrócony</h2>`);
				}
				if (page == 'basket') {
					if($('#basket.delivery-mode').length){
						setAction(action, cart);
					} else {
						setAction(action, cart, function () {
							broker.trigger('REFRESH_BASKET_VIEW');
						});
					}
				} else if (page.indexOf('delivery') > 0) {
					setAction(action, cart);
				}
			}).on('click', '.js-cart-retrieve-more', function () {
				modal.open('cart-retrieve');
				logAction('open-details');
			});
		}
		if ($('#cart-retrieve').length) {
			logAction('wyświetlenie - ścieżka');
		}
	}
	function checkIfBundleModal(){
		if (sessionStorage.getItem(CART_MERGE_BUNDLE) === 'true') {
			message.get('cart.bhtml - cart-merge-bundle').then(function (result) {
				sessionStorage.removeItem(CART_MERGE_BUNDLE);
				modal.generate({
					id: 'modal-cart-merge-bundle',
					content: result,
					buttons: [{
						text: 'Sprawdź koszyk',
						cssClass: 'btn-second',
						click: function () {
							modal.close();
						}
					}]
				});
			});
		}
	}
	return {
		init, checkIfBundleModal
	};
});
